import React, { useMemo } from 'react'
import styles from 'components/Filters/FilterPanel/subcomponents/SubButtons/subbuttons.module.scss'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import isEqual from 'lodash/isEqual'
import { Button, Icon, Typography } from 'gu-ui-kit'

const Label = ({ filterManager, filterKey }) => {
  const { t } = useTranslation()
  const { clearFilter, filters, configuration, initial } = filterManager

  const value = useMemo(() => {
    let phrase = t('common::select_value')

    if (filters?.[filterKey]?.length > 0) {
      phrase = Array.isArray(filters[filterKey])
        ? filters[filterKey]?.length > 3
          ? t('common::filters.label_multiple_values', {
              count: filters[filterKey].length,
            })
          : filters[filterKey]
              .map((val) => t(configuration[filterKey].optionLabelPrefix + val))
              .join(', ')
        : t(
            configuration[filterKey].optionLabelPrefix
              ? configuration[filterKey].optionLabelPrefix + filters[filterKey]
              : filters[filterKey],
          )
    }

    return phrase
  }, [filters, t])

  const showClearButton = useMemo(
    () => filters?.[filterKey]?.length > 0 && !isEqual(filters?.[filterKey], initial?.[filterKey]),
    [filters, initial],
  )

  return (
    <div
      className={styles['subbuttons-filter']}
      key={'applied-filter-' + filterKey}
    >
      <Typography variant={'Body-15'}>
        {t(configuration[filterKey].label)}: {value}
      </Typography>
      {showClearButton && (
        <Button
          type="button"
          noLabel
          title={t('common::buttons.clear')}
          onClick={() => clearFilter(filterKey)}
          size={'s'}
          variant={'ghost'}
          grey
          link
          noHover
          className={styles['subbuttons-filter__delete-button']}
          startIcon={<Icon name={'close'} />}
        />
      )}
    </div>
  )
}

Label.propTypes = {
  filterManager: PropTypes.object,
  filterKey: PropTypes.string,
}

export default Label
